import { DeepPartial, DeepReadonly } from 'ts-essentials';
import {
    ISlideSizeProps,
    SlideSizeType,
} from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import { ICTSlideSize, STSlideSizeType } from '@tencent/slide-sdk-model';
import { emuToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import { checkSlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/operation';

export class SlideSizeConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTSlideSize>>,
        uiData: ISlideSizeProps,
    ): void {
        if (sdkData.cx !== undefined) {
            uiData.slideWidth = emuToCanvas(sdkData.cx);
        }
        if (sdkData.cy !== undefined) {
            uiData.slideHeight = emuToCanvas(sdkData.cy);
        }
        if (sdkData.type !== undefined) {
            uiData.type = sdkData.type;
        }
        if (uiData.slideWidth && uiData.slideHeight) {
            uiData.slideSizeType = checkSlideSizeType(uiData.slideWidth, uiData.slideHeight);

            // 目前看来，导入的数据type有问题，先额外处理一下，后续把所有type统一成ooxml的
            if (uiData.slideSizeType === SlideSizeType.SLIDE_SIZE_CUSTOM) {
                uiData.type = STSlideSizeType.custom;
            }
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<ISlideSizeProps>,
        sdkData: ICTSlideSize,
    ): void {

    }
}
